import { Link } from "@chakra-ui/react";
import { ImageFeatureCard, type ImageFeatureCardProps } from "components/cards";
import { ThreeCardGrid } from "components/grids";
import React from "react";
import feature1Image from "../../../../public/assets/solutions/advertising/campaign-intelligence-feature-1.png";
import feature2Image from "../../../../public/assets/solutions/advertising/campaign-intelligence-feature-2.png";
import feature3Image from "../../../../public/assets/solutions/advertising/campaign-intelligence-feature-3.png";

export function CampaignIntelligenceFeatures() {
  const features: ImageFeatureCardProps[] = [
    {
      image: feature1Image,
      title: "Self-serve analytics that breaks down silos",
      description: (
        <>
          Compare attribution models, analyze funnels, and explore journeys. Ask any question your data can answer in
          plain English with{" "}
          <Link variant="article" _hover={{ color: "gray.800" }} href="/platform/campaign-intelligence#copilot">
            Hightouch Copilot AI
          </Link>
          .
        </>
      ),
    },
    {
      image: feature2Image,
      title: "Measure incremental lift across every channel",
      description:
        "Measure the true impact of every new channel and campaign. Factor in non-media channels like email to  make the best investments for everyone.",
    },
    {
      image: feature3Image,
      title: "Collaborate on insights in a privacy-safe environment",
      description:
        "Sync your data to supported clean room destinations to better understand reach & frequency, analyze audience overlap, link ad exposures to purchases, and more.",
    },
  ];

  return (
    <ThreeCardGrid>
      {features.map((feature) => (
        <ImageFeatureCard key={feature.title} {...feature} />
      ))}
    </ThreeCardGrid>
  );
}
